/* src/app/modules/investment/intangible-material/investment-dialog-pay.component.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.ip-header-text {
  min-width: 0;
  padding-right: 32px;
}
.ip-body {
  padding: 0 !important;
}
.ip-remaining {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 24px;
  background:
    linear-gradient(
      135deg,
      #fbfee8 0%,
      #f4fbd0 100%);
  border-bottom: 1px solid #e5f3a0;
}
.ip-remaining__left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.ip-remaining__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ip-remaining__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #1a1d23;
}
.ip-remaining__label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6b7280;
}
.ip-remaining__amount {
  display: block;
  font-size: 22px;
  font-weight: 700;
  color: #1a1d23;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}
.ip-remaining__hint {
  display: block;
  font-size: 12px;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
}
.ip-remaining__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ip-section {
  padding: 18px 24px 6px;
  border-bottom: 1px solid #f0f0f0;
}
.ip-section:last-child {
  border-bottom: none;
  padding-bottom: 18px;
}
.ip-section .cf-dlg-section__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.ip-link {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  color: #6b7280;
  cursor: pointer;
}
.ip-link:hover {
  color: #1a1d23;
  text-decoration: underline;
}
.ip-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0 16px;
}
.ip-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #4b5563;
}
.ip-alert mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #6b7280;
}
.ip-alert--error {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
}
.ip-alert--error mat-icon {
  color: #dc2626;
}
.ip-paid {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  margin-bottom: 12px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #16a34a;
}
.ip-paid mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.ip-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.ip-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.ip-row--editing {
  border-color: #c5d94a;
  background: #fbfee8;
}
.ip-row__main {
  flex: 1;
  min-width: 0;
}
.ip-row__amount {
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ip-row__meta {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ip-row__date {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
  flex-shrink: 0;
}
.ip-row__actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.ip-row__btn {
  width: 32px !important;
  height: 32px !important;
  padding: 4px !important;
  color: #6b7280 !important;
}
.ip-row__btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.ip-row__btn--danger:hover {
  color: #dc2626 !important;
}
@media (max-width: 600px) {
  .ip-remaining {
    flex-direction: column;
    align-items: flex-start;
  }
  .ip-section {
    padding: 14px 16px 6px;
  }
  .ip-row {
    flex-wrap: wrap;
  }
  .ip-row__main {
    flex-basis: 100%;
  }
}
/*# sourceMappingURL=investment-dialog-pay.component.css.map */
